<div class="mega-overlay">
  <div class="error-holder">
    <div class="status">500</div>
    <div class="h2">Internal server error</div>
    <p>Well, that wasn't supposed to happen. Please try again in a moment.</p>
    <button class="btn btn-secondary" (click)="dismissClicked()">Dismiss</button>
  </div>
</div>
